import * as Tone from "tone";
import { Timeline } from "../project/Timeline";
import { Composer } from "../Composer";
import { Instrument } from "../instruments/Instrument";
import { AudioMath } from "../../AudioMath";
import { Note } from "../notes/Note";

export class NoteEventData
{
  time:string|number;
  note:string; 
  velocity:number;
  duration:number;
}

export class EventsCache
{
  instrument:Instrument;

  parts = new Map<number,Tone.Part>();

  addParts( notes:Note[], callback:( duration:number, d:NoteEventData )=>void )
  {
    let composer = Composer.$;
    let converter = 1.0 / composer.project.settings.partResolutionBeats;
    let bpm = composer.bpm;

    console.log( { bpm } );
    let blocks = new Map<number,Note[]>();

    notes.forEach(
      ( n )=>
      {
        let blockIndex = Math.floor( n.start * converter );

        if ( ! blocks.has( blockIndex ) )
        {
          blocks.set( blockIndex, [] );
        }

        let blockList = blocks.get( blockIndex );

        blockList.push( n );       
      }
    );
    
    blocks.forEach(
      ( notes, blockIndex )=>
      {
        let noteData:NoteEventData[] = [];

        notes.forEach(
          ( n )=>
          {
            let note:NoteEventData =
            {
              time: AudioMath.beatsToSeconds( n.start, bpm ),
              note: n.keyInfo,
              velocity: n.velocity,
              duration: AudioMath.beatsToSeconds( n.duration, bpm )
            }

            noteData.push( note );

          }
        );

        console.log( "CREATING PART", blockIndex, notes, noteData );
        let part = new Tone.Part( callback, noteData );
        part.loopStart = AudioMath.beatsToSeconds( Composer.$.activeTimeline.start, bpm );
        part.loopEnd   = AudioMath.beatsToSeconds( Composer.$.activeTimeline.end, bpm );
        part.loop = true;

        part.start( part.loopStart );

        this.parts.set( blockIndex, part );
        
      }
    );

  }

  clearPartsInRange( cacheStartIndex:number, cacheLength:number )
  {
    for ( let i = 0; i < cacheLength; i++ )
    {
      let index = i + cacheStartIndex;

      if ( this.parts.has( index ) )
      {
        let part = this.parts.get( index );
        this.clearPart( part );
        this.parts.delete( index );
      }
    }
  }

  clearPart( part:Tone.Part )
  {
    part.cancel();
    part.clear();
    part.dispose();
  }
}
